export const ARVIEWER_QUERIES = {
  noBackground: 'disableBackground=true',
  vrmakerOnly: 'onlyForVRmaker=true'
}

export const ARVIEW_POPUP = {
  ACTION_TARGET: 'iframe',
  WIDTH_PERCENT: 65
}

export const AR_VIEW_ENABLE_MARKERS = [
  'tag',
  'multitag'
]

export const isArViewerUrl = (url) => {
  return /^https:\/\/arviewer(-dev)?.istaging.com/.test(url)
}
